import { RecordCard } from '../../../components/primitives/RecordCard';
import type { BoardWorkItemRow } from './types';
import { WorkItemCardChips } from './WorkItemCardChips';

export function BoardCardPreview({
  card,
  chips
}: {
  card: BoardWorkItemRow;
  chips: ReadonlyArray<{ key: string; value: string | null }>;
}) {
  return (
    <RecordCard
      layout="row"
      className="pn-record-card--overlay"
      data-status={card.status}
    >
      <RecordCard.Lead>
        <RecordCard.DragRail preview aria-hidden />
      </RecordCard.Lead>
      <RecordCard.Body>
        <RecordCard.Title>{card.name}</RecordCard.Title>
        <WorkItemCardChips
          chips={chips.map((c) => ({ ...c, isEpicLink: false, parentId: null }))}
          cardId={card.id}
          testIdPrefix="work-items-route-board-card"
        />
      </RecordCard.Body>
    </RecordCard>
  );
}
